import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

export default {
    container: (): string => "flex flex-col rounded-full group",
    headerWrapper: ({ isExpandable }: { isExpandable: boolean }): string =>
        buildCssClassName("flex", "items-center", { "!cursor-default": !isExpandable }),
    headerTrigger: ({ isExpandable }: { isExpandable: boolean }): string =>
        buildCssClassName(
            "flex",
            "flex-1",
            "items-center",
            "gap-x-[10px]",
            "bg-transparent",
            "border-0",
            "p-0",
            "text-left",
            "outline-offset-[3px]",
            { "cursor-pointer": isExpandable, "!cursor-default": !isExpandable }
        ),
    iconsContainer: (): string =>
        "flex items-center justify-between gap-x-[5px] md:gap-x-[10px] lg:gap-x-[20px] translate-x-[-15px]",
    body: (): string =>
        buildCssClassName("flex overflow-hidden", getTransitionTwClasses("[max-height]", 300, "ease-in")),
    bodyContent: (): string => "w-full"
} as const
